import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { APIRequestService } from "src/app/shared/services/api/apirequest.service";
import { Observable } from "rxjs";

import { map } from "rxjs/operators";

import { APIURLTypes } from "src/app/shared/enums/apiurltypes.enum";
import { HelperService } from "src/app/shared/services/helper.service";
import { apiUrlparts } from "src/app/shared/enums/apiurlparts.const";
import { ScanResult } from "./scan.model";
import { PartnerModule } from "@app/partner/partner.module";

@Injectable({
  providedIn: "root",
})
export class ScanhistoryService {
  constructor(
    private apiRequest: APIRequestService,
    private helperService: HelperService
  ) {}

  getScanResultById(id): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append("scan_id", id);
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.scanDetail + params
      )
    );
  }

  getScanQualixCheckResultById(id): Observable<any> {
   
    return this.apiRequest.get('', null, this.helperService.urlFactory(APIURLTypes.SCM, (apiUrlparts.scanQualityCheckDetail + id)));
  }

  getOutboundOrInboundScanResultById(id): Observable<any> {
   
    return this.apiRequest.get('', null, this.helperService.urlFactory(APIURLTypes.SCM, (apiUrlparts.scanResult + id)));
  }

  getScanReactiveResultById(id): Observable<any> {
    // let params: HttpParams = new HttpParams();
    // params = params.append('scan_id', id);
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.REACTIVE,
        apiUrlparts.scanDetailReactive + id
      )
    );
  }

  getScanImagetById(id): Observable<any> {
    return this.apiRequest.getPdf(
      "",
      null,
      this.helperService.urlFactory(APIURLTypes.SCM, apiUrlparts.scanImage + id)
    );
  }

  getAllScanData(dateFrom: number, dateTo: number): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append('date_from', dateFrom.toString());
    params = params.append('date_to', dateTo.toString());

    let customerId = this.helperService.getCustomerId()
    if (customerId) {
      params = params.append('client_id',customerId);
    }
    return this.apiRequest.getPdf('' + params, null, this.helperService.urlFactory(APIURLTypes.SCM, (`${apiUrlparts.allScanData}?` + params)));
  }

  // getAllScanData(): Observable<any> {
  //   let params: HttpParams = new HttpParams();
  //   if (+this.helperService.stateId > 0) {
  //     params = params.append("state_id", this.helperService.stateId);
  //   }
  //   if (+this.helperService.commodityIdTobePassToAPI > 0) {
  //     params = params.append(
  //       "commodity_id",
  //       this.helperService.commodityIdTobePassToAPI
  //     );
  //   }
  //   return this.apiRequest.getPdf(
  //     "" + params,
  //     null,
  //     this.helperService.urlFactory(
  //       APIURLTypes.SCM,
  //       `${apiUrlparts.allScanData}?` + params
  //     )
  //   );
  // }

  getAllScanImageIDs(scanid): Observable<any> {
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.scanImage + scanid
      )
    );
  }
  getOutboundQCScanImageIDs(scanid): Observable<any> {
    return this.apiRequest.get('', null, this.helperService.urlFactory(APIURLTypes.SCM, (apiUrlparts.scanQCOutboundImage + scanid)));
  }
  downloadImageByID(id,scanid,filename): Observable<any> {
    return this.apiRequest.getPdf('', null, this.helperService.urlFactory(APIURLTypes.SCM, (apiUrlparts.scanImageDownload + id + '/'+scanid+'?fileName='+filename)));
  }

  getPDF(id): Observable<any> {
    return this.apiRequest.getPdf(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.scanPDFDownload + id
      )
    );
  }

  getQCPDF(id): Observable<any> {
    return this.apiRequest.getPdf(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.qcscanPDFDownload + id
      )
    );
  }

   getScanList(
    commodityId?: number,
    stateId?: number,
    sortBy?: string,
    sortType?: string,
    pageindex?,
    pagesize?,
    dateFrom?: number, 
    dateTo?: number,
    commodityCategoryId?,
    devices? : string[],
    assayingType?,
    farmerOrTruckfitler?,
    // 
    installationCenterId?,
    customerId?,
    locationId?: number,
    device_type?: number,
    leafType?,
    userId?: any
  ): Observable<any> {
    let params: HttpParams = new HttpParams();
    if (sortBy) {
      params = params.append("sortingParameterName", sortBy);
    }
    if (sortType && sortBy) {
      params = params.append("sortingOrder", sortType);
    }
    if (pageindex) {
      params = params.append("pageNumber", pageindex);
    }
    if (pagesize) {
      params = params.append("limit", pagesize);
    }
    if (dateFrom) {
      params = params.append("dateFrom", dateFrom?.toString());
    }
    if (dateTo) {
      params = params.append("dateTo", dateTo?.toString());
    }
    // if (installationCenterId) {
    //   params = params.append("installationCenterId", installationCenterId);
    // }
    if (commodityCategoryId) {
      params = params.append("categoryId", commodityCategoryId);
    }
    if (devices) {
      devices.forEach(d => {
        params = params.append("deviceSerialNumber", d);
      });
    }
    if (stateId > 0) {
      params = params.append("stateId", stateId.toString());
    }

    if (customerId) {
      params = params.append("customerId", customerId);
    }

    if (commodityId > 0) {
      params = params.append("commodityId", commodityId.toString());
    }

      if (assayingType) {
        params = params.append("assayingType", assayingType);
        if (farmerOrTruckfitler) {
          if (assayingType == "INBOUND") {
            params = params.append("farmerContactNumber", farmerOrTruckfitler);
          } else {
            params = params.append("truckNumber", farmerOrTruckfitler);
          }
        }
      }
    if (locationId) {
      params = params.append("locationId", locationId.toString());
    }
    if (device_type) {
      params = params.append("device_type", device_type.toString());
    }

    if (leafType && leafType !=this.helperService.selectLeafType) {
      params = params.append('sample_type', leafType);
    }

    if (userId) {
      params = params.append('userId', userId.toString());
    }

    return this.apiRequest.get(
      "" + params,
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.scanHistoryv2 + params
      )
    );
  }

  public getScanDropdown(): Observable<any> {
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(APIURLTypes.SCM, apiUrlparts.scanDropDown)
    );
  }

  getScanListFromReactiveApis(
    commodityId: number,
    stateId: number,
    sortBy: string,
    sortType: string,
    pageindex,
    pagesize,
    dateFrom: number,
    dateTo: number,
    commodityCategoryId,
    location_id?
  ): Observable<any> {
    let params: HttpParams = new HttpParams();
    // if (sortBy) {
    //   params = params.append('sort_by', sortBy);
    // }
    // if (sortType && sortBy) {
    //   params = params.append('sort_type', sortType);
    // }
    params = params.append("pageNumber", pageindex);
    params = params.append("limit", pagesize);
    //params = params.append('customer_id', this.helperService.getCustomerId().toString());
    params = params.append(
      "clientId",
      this.helperService.getCustomerId().toString()
    );
    params = params.append(
      "dateFrom",
      new Date(dateFrom).toISOString().split("T")[0]
    );
    params = params.append(
      "dateTo",
      new Date(dateTo).toISOString().split("T")[0]
    );
    // params = params.append('commodity_category_id', commodityCategoryId);
    if (location_id) {
      params = params.append("installationCentreId", location_id);
    }
    // if (stateId > 0) {
    //   params = params.append('state_id', stateId.toString());
    // }

    if (commodityId > 0) {
      params = params.append("commodity", commodityId.toString());
    }

    return this.apiRequest.get(
      "" + params,
      null,
      this.helperService.urlFactory(
        APIURLTypes.REACTIVE,
        apiUrlparts.scanReactiveHistory + params
      )
    );
  }

  getScanInfo(id): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append("scan_id", id);
    // params = params.append('inst_center_id', id);
    // params = params.append('device_type', id);
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.scanInfo + params
      )
    );
  }

  getScanQualityCheckInfo(id): Observable<any> {
    //let params: HttpParams = new HttpParams();
    //params = params.append('scan_id', id);
    
    return this.apiRequest.get('', null, this.helperService.urlFactory(APIURLTypes.SCM, (apiUrlparts.scanQualityCheckInfo + id)));
  }

  getScanReactiveInfo(id): Observable<any> {
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.REACTIVE,
        apiUrlparts.scanInfoReactive + id
      )
    );
  }

  getCompositeScans(id): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append("scan_id", id);
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.compositescans + params
      )
    );
  }

  changeScanStatus(datap) {
    return this.apiRequest.put(
      "",
      datap,
      this.helperService.urlFactory(
        APIURLTypes.IAM,
        apiUrlparts.scanStatusChange
      )
    );
  }

  public getScanListResult(
    pageindex,
    pagesize,
    deviceSerialNo,
    commodityId
  ): Observable<ScanResult> {
    let params: HttpParams = new HttpParams();
    params = params.append("p", pageindex);
    params = params.append("l", pagesize);
    params = params.append("device_serial_number", deviceSerialNo);
    params = params.append("commodity_id", commodityId);
    return this.apiRequest.get(
      "" + params,
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.scanList + params
      )
    );
  }

  public getDuplicateScanList(pageindex, pagesize): Observable<ScanResult> {
    let params: HttpParams = new HttpParams();
    params = params.append("p", pageindex);
    params = params.append("l", pagesize);

    return this.apiRequest.get(
      "" + params,
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.duplicatescans + params
      )
    );
  }

  public getEditableScan(scanid) {
    let params: HttpParams = new HttpParams();
    if (scanid) {
      params = params.append("scan_id", scanid);
    }

   
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.geteditablescan + params
      )
    );
  }

  public getScanBySampleId(customerid, sampleid) {
    let params: HttpParams = new HttpParams();
    params = params.append("customer_id", customerid);
    params = params.append("sample_id", sampleid);
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.getscanbysampleid + params
      )
    );
  }

  public getScanVerify(scanId) : any {
    let params:HttpParams = new HttpParams();
    params = params.append("scan_id", scanId);

    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.verifyScan + params
      )
    );
  }

  public putScan(scandata, scanid) {
    return this.apiRequest.put(
      "",
      scandata,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.putScan + scanid
      )
    );
  }

  public removeScan(scanid) {
    return this.apiRequest.delete(
      "",
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.removeScan + scanid
      )
    );
  }

  public getHederaTransactions(userId?: any){
    let params: HttpParams = new HttpParams();
    if (userId) {
      params = params.append('userId', userId);
    }
    return this.apiRequest.get(
      "",
      null,
      this.helperService.urlFactory(
        APIURLTypes.SCM,
        apiUrlparts.hederaTransactions + '?' + params
      )
    );
  }
}
